import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { IonicModule } from "ionic-angular";
import { BsDatepickerModule } from "ngx-bootstrap";
import { DateTimeComponent } from "./date-time.component";

@NgModule({
    imports: [
        CommonModule,
        IonicModule,
        BsDatepickerModule.forRoot()
    ],
    declarations: [
        DateTimeComponent
    ],
    exports: [
        DateTimeComponent
    ]
})
export class DateTimeModule {

}



// WEBPACK FOOTER //
// ./src/vas/modules-shared/controls/date-time/date-time.module.ts